/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/visual-exercise/v1.ts
 */

import { createValidator } from '../../helpers/validator';
export const VisualExerciseV1Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    asset: {
      type: 'object',
      properties: {
        assetType: {
          type: 'string',
          enum: ['Image', 'Video'],
          title: 'Asset type',
          description: 'The type of visual asset for this exercise'
        },
        assetUrl: {
          type: 'string',
          title: 'Asset Url',
          description: 'The url to the visual asset for this exercise',
          pattern: '^https://(learn-api|videos|assets)\\.datacamp(-staging)?\\.com/.*'
        }
      },
      required: ['assetType', 'assetUrl'],
      title: 'Asset'
    },
    question: {
      anyOf: [{
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['SingleOpenQuestion'],
            default: 'SingleOpenQuestion'
          },
          question: {
            type: 'string',
            description: 'The question that the student has to answer.'
          },
          solution: {
            type: 'object',
            properties: {
              answer: {
                type: 'string',
                description: 'Correct answer to the question.'
              },
              message: {
                type: 'string',
                description: 'Feedback message when the submission matches the pattern.'
              },
              pattern: {
                type: 'string',
                description: 'Regex that should validate the correctness of the submission.'
              }
            },
            required: ['answer', 'message', 'pattern']
          },
          feedback: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                message: {
                  type: 'string',
                  description: 'Feedback message when the submission matches the pattern.'
                },
                pattern: {
                  type: 'string',
                  description: 'If the regex matches, the feedback message will be shown. The last pattern should be ".*" to show a default error message.'
                }
              },
              required: ['message', 'pattern']
            },
            description: 'List of feedback displayed when the submission is incorrect.'
          }
        },
        required: ['feedback', 'flavor', 'question', 'solution'],
        title: 'SingleOpenQuestion'
      }, {
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['PureMultipleChoice'],
            default: 'PureMultipleChoice'
          },
          solutionItems: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                answer: {
                  type: 'string',
                  default: 'Wrong answer',
                  description: 'Possible answer choice.'
                },
                feedback: {
                  type: 'string',
                  default: 'Error message',
                  description: 'Feedback message for the submission. For the correct answer this is the success message.'
                },
                correct: {
                  type: 'boolean',
                  default: false,
                  description: 'Check a single box for the correct answer.'
                }
              },
              required: ['answer', 'feedback', 'correct']
            },
            description: 'List of possible answers. Use the arrows on the left-hand side to change the order, or the X to remove the item.'
          }
        },
        required: ['flavor', 'solutionItems'],
        title: 'SingleCorrectAnswer'
      }, {
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['PureMultipleAnswers'],
            default: 'PureMultipleAnswers'
          },
          successMessage: {
            type: 'string',
            default: 'Well done!',
            description: 'Feedback message when the submission is correct.'
          },
          solutionItems: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                answer: {
                  type: 'string',
                  default: 'Wrong answer',
                  description: 'Possible answer choice.'
                },
                feedback: {
                  type: 'string',
                  default: 'Error message',
                  description: 'Feedback message when the submission is incorrect.'
                },
                correct: {
                  type: 'boolean',
                  default: false,
                  description: 'Check the box if the answer is correct.'
                }
              },
              required: ['answer', 'feedback', 'correct']
            },
            default: 'Well done!',
            description: 'List of possible answers. Use the arrows on the left-hand side to change the order, or the X to remove the item.'
          }
        },
        required: ['flavor', 'solutionItems', 'successMessage'],
        title: 'MultipleCorrectAnswers'
      }]
    }
  },
  required: ['asset', 'assignment', 'chapter_id', 'course_id', 'hint', 'question', 'title', 'xp'],
  definitions: {}
};
export const isValidVisualExerciseV1 = createValidator(VisualExerciseV1Schema);
export const VisualExerciseV1Definition = {
  schema: VisualExerciseV1Schema,
  validate: isValidVisualExerciseV1
};